import { useEffect, useState } from 'react';
import { MORPH_BTN_SM } from '../../lib/ui.js';

const CLOSE_DURATION = 220; // ms, samakan dengan durasi keyframe loginPanelOut/loginBackdropOut di index.css

/**
 * Dialog "Login Berhasil" — kerangka & animasi masuknya sama dengan
 * InstallAppModal (backdrop fade + panel spring-in), ditambah animasi
 * keluar yang halus (fade + scale down) sebelum benar-benar dilepas dari DOM.
 */
export default function LoginSuccessModal({ open, onClose }) {
  const [mounted, setMounted] = useState(open);
  const [closing, setClosing] = useState(false);

  // Sinkron dengan prop `open`: saat true langsung tampil, saat false mainkan
  // animasi keluar dulu baru benar-benar dilepas dari DOM
  useEffect(() => {
    if (open) {
      setMounted(true);
      setClosing(false);
    } else if (mounted) {
      setClosing(true);
      const t = setTimeout(() => { setMounted(false); setClosing(false); }, CLOSE_DURATION);
      return () => clearTimeout(t);
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!mounted || closing) return;
    const onKey = (e) => { if (e.key === 'Enter' || e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.classList.add('modal-open');
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.classList.remove('modal-open');
    };
  }, [mounted, closing, onClose]);

  if (!mounted) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4">
      <div className={`absolute inset-0 bg-black/50 backdrop-blur-sm ${closing ? 'login-modal-backdrop-out' : 'install-modal-backdrop'}`} aria-hidden="true" />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Login berhasil"
        className={`relative w-full max-w-xs rounded-3xl border border-white/50 dark:border-neutral-700/60 bg-white/95 dark:bg-neutral-900/95 backdrop-blur-md shadow-[0_20px_60px_rgba(0,0,0,0.35)] p-7 flex flex-col items-center text-center ${closing ? 'login-modal-panel-out' : 'install-modal-panel'}`}
      >
        <div className="relative w-20 h-20 mb-5 flex items-center justify-center">
          <span className="login-success-ring absolute inset-0 rounded-full" style={{ background: 'color-mix(in oklab, var(--accent) 18%, transparent)' }} />
          <span
            className="login-success-icon material-symbols-outlined relative text-6xl"
            style={{ color: 'var(--accent)', fontVariationSettings: "'FILL' 1" }}
          >
            check_circle
          </span>
        </div>

        <h3 className="font-display font-extrabold text-lg text-neutral-900 dark:text-white mb-1">Login Berhasil</h3>
        <p className="text-sm text-neutral-500 dark:text-neutral-400 mb-6">Selamat datang kembali, kamu akan diarahkan ke dashboard admin.</p>

        <button
          onClick={onClose}
          autoFocus
          className={`w-full h-11 rounded-[20px] text-sm font-extrabold text-white shadow-md ${MORPH_BTN_SM}`}
          style={{ backgroundColor: 'var(--accent)' }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
